<template>
  <div class="modeList" @click="detail">
    <div class="modeList-title">
      {{ item.servername ? item.servername : "-" }}
    </div>
    <ul>
      <li class="modeList-item">
        <span>服务器地址:</span>
        <p>{{ item.serveraddr ? item.serveraddr : "-" }}</p>
      </li>
    </ul>
    <ul class="modeList-textarea">
      <li>
        <span>端口号:</span>
        <p>{{ item.serverport ? item.serverport : "-" }}</p>
      </li>
      <li>
        <span>创建人:</span>
        <p>{{ item.cjr ? item.cjr : "-" }}</p>
      </li>
      <li>
        <span>缓存名称:</span>
        <p>{{ item.servertype ? item.servertype : "-" }}</p>
      </li>
      <li>
        <span>创建时间:</span>
        <p>{{ item.cjsj ? item.cjsj : "-" }}</p>
      </li>
    </ul>
    <div class="modeList-num">
      <p>{{ item.zxrs ? item.zxrs : "-" }}</p>
      <span>在线人数</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "modeList",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    detail() {
      this.$emit("detail", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.modeList {
  position: relative;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  .modeList-title {
    width: calc(~"100% - 70px");
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    line-height: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 13px;
  }
  .modeList-item {
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    span {
      white-space: nowrap;
    }
    p {
      white-space: wrap;
      margin-left: 5px;
    }
    & + .modeList-item {
      margin-top: 8px;
    }
  }
  .modeList-textarea {
    display: flex;
    flex-wrap: wrap;
    margin-top: 11px;
    background-image: linear-gradient(
      90deg,
      #f2f2f4 0%,
      rgba(242, 242, 244, 0) 100%
    );
    border-radius: 4px;
    padding: 6px;
    box-sizing: border-box;
    li {
      display: flex;
      box-sizing: border-box;
      width: calc(~"50% - 6px");
      font-family: SourceHanSansCN-Regular;
      line-height: 25px;
      padding: 0 6px;
      span {
        white-space: nowrap;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        font-weight: 400;
      }
      p {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
        margin-left: 5px;
      }
    }
  }
  .modeList-num {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 13px;
    right: 15px;
    width: 66px;
    height: 44px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: center;
      font-weight: bolder;
      line-height: 22px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkztck/modeList.vue